import React from 'react';

import { Typography, Grid } from '@material-ui/core';
import { makeStyles, useTheme } from '@material-ui/core/styles';
import useMediaQuery from '@material-ui/core/useMediaQuery';

import { useInView } from 'react-intersection-observer';

import stat1 from '../assets/40js.svg';

import blueOrb from '../assets/blueOrb.svg';

const useStyles = makeStyles((theme) => ({
  orb: {
    position: 'absolute',
    right: 0,
    top: 800,
    [theme.breakpoints.down('sm')]: {
      display: 'none'
    }
  },
  container: {
    marginTop: '4rem'
  },
  contentCont: {
    width: '51%',
    [theme.breakpoints.down('sm')]: {
      width: '75%'
    }
  },
  textCont: {
    width: '60%',
    marginLeft: 0,
    [theme.breakpoints.down('sm')]: {
      width: '100%'
    }
  },
  piecharts: {
    width: '30%',
    marginLeft: '4rem',
    [theme.breakpoints.down('sm')]: {
      marginTop: '3.8rem',
      marginLeft: 0,
      width: '100%'
    }
  },
  responsiveH4: {
    [theme.breakpoints.down('sm')]: {
      fontSize: '1.6rem'
    }
  },
  pieChartDescrip: {
    width: '100%',
    textAlign: 'center',
    [theme.breakpoints.down('sm')]: {
      width: '60%'
    }
  }
}));

const Stats1 = (props) => {
  const classes = useStyles();
  const theme = useTheme();
  const matchesSM = useMediaQuery(theme.breakpoints.down('sm'));

  const { ref, inView } = useInView({ threshold: 0.2, triggerOnce: 'true' });

  const renderer = (
    <>
      <Grid container direction="column" alignItems="center" style={{ marginBottom: '1.5rem' }}>
        <object
          type="image/svg+xml"
          data={stat1}
          aria-label="pie chart animation"
          style={{ width: '190px', marginBottom: '1.2rem' }}
        ></object>
        <Typography variant="body2" className={classes.pieChartDescrip}>
          Black women are 40% more likely to die from breast cancer compared to white women.
          <sup>1</sup>
        </Typography>
      </Grid>
      <Grid container direction="column" alignItems="center">
        <object
          type="image/svg+xml"
          data={stat1}
          aria-label="pie chart animation"
          style={{ width: '190px', marginBottom: '1.2rem' }}
        ></object>
        <Typography variant="body2" className={classes.pieChartDescrip}>
          Hispanic women are faced with a <span style={{ fontFamily: 'proximaNovaB' }}>40%</span>{' '}
          higher rate of diagnosis for cervical cancer, and are{' '}
          <span style={{ fontFamily: 'proximaNovaB' }}>20%</span> more likely to die from the
          disease compared to non-Hispanic white women.
          <sup>2</sup>
        </Typography>
      </Grid>
    </>
  );

  return (
    <>
      <img src={blueOrb} alt="blue fading orb graphic" className={classes.orb} />
      <Grid container justifyContent="center" alignItems="center" className={classes.container}>
        <Grid
          container
          item
          direction={matchesSM ? 'column' : 'row'}
          alignContent="center"
          justifyContent="center"
          className={classes.contentCont}
        >
          <Grid container item className={classes.textCont}>
            <Typography variant="h4" className={classes.responsiveH4} paragraph>
              Cancer doesn’t or shouldn’t discriminate when it comes to age, background, or
              ethnicity. But for Black and Hispanic women in America, the numbers tell another
              story– and it’s one that should concern everyone.
            </Typography>
            <Typography variant="h4" className={classes.responsiveH4} paragraph>
              While the reasons behind these gaps are complex and multivalent, these statistics are
              a reminder that racial disparities come in many malignant forms.
            </Typography>
          </Grid>

          <Grid
            ref={ref}
            container
            item
            direction="column"
            alignItems="center"
            className={classes.piecharts}
          >
            {inView ? renderer : null}
          </Grid>
        </Grid>
      </Grid>
    </>
  );
};

export default Stats1;
